import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinimize315: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="minimize-315, arrow, shrink"><path d="M10.25 3.75V10.25H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 20.25V13.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.5 9.5L3.75 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.5 14.5L20.25 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMinimize315;
